import React from 'react';

//Styles
import Styles from './SwitchInput.module.scss';

//Utils
import PropTypes from 'prop-types';

const SwitchInput = ({name, id, value, switchHandler}) => {   

    return (  
        <div className={Styles.container}>
            <button 
                onClick={() => {
                    switchHandler(id, !value)
                }}
                className={[Styles.switch, value ? Styles.checkedSwitch : ''].join(' ')}>
                <label
                    className={[Styles.thumb, value ? Styles.checked : ''].join(' ')}
                />
            </button>
  
            <input
                onClick={() => {
                    switchHandler(id, !value)
                }}
                value={name}
                type='button'
            />
        </div>
    );
};

SwitchInput.propTypes = {
    switchHandler: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
};

export default SwitchInput
